"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var lodash_1 = require("lodash");
var vertical_card_scss_includeInitial_1 = tslib_1.__importDefault(require("./vertical-card.scss?includeInitial"));
var live_statuses_1 = require("@wix/wix-vod-constants/dist/common/live-statuses");
var description_1 = tslib_1.__importDefault(require("./description/description"));
var cta_1 = tslib_1.__importDefault(require("./cta/cta"));
var thumbnail_placeholder_icon_1 = tslib_1.__importStar(require("./thumbnail-placeholder-icon/thumbnail-placeholder-icon"));
var types_1 = require("@wix/wix-vod-constants/dist/video-cards/types");
var withStyles_1 = require("../../../../utils/withStyles");
exports.VERTICAL_VIDEO_CARD_WIDTH = 210;
var VerticalVideoCard = /** @class */ (function (_super) {
    tslib_1.__extends(VerticalVideoCard, _super);
    function VerticalVideoCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleCardClick = function () {
            var _a = _this.props, cardData = _a.cardData, onCardClick = _a.onCardClick;
            onCardClick(cardData);
        };
        return _this;
    }
    VerticalVideoCard.prototype.isScheduledVideo = function () {
        var itemType = this.props.cardData.itemType;
        return itemType === live_statuses_1.LIVE_STATUSES.SCHEDULED;
    };
    VerticalVideoCard.prototype.hasCTA = function () {
        var _a = this.props.cardData, buttonLabel = _a.buttonLabel, network = _a.network;
        return Boolean(buttonLabel || network) && !this.isScheduledVideo();
    };
    VerticalVideoCard.prototype.renderThumbnail = function () {
        var _a;
        var _b = this.props.cardData, thumbnailUrl = _b.thumbnailUrl, type = _b.type, itemType = _b.itemType;
        var isPlayable = lodash_1.includes(thumbnail_placeholder_icon_1.PLAYABLE_VIDEO_CARD_TYPES, type);
        var style = thumbnailUrl
            ? { backgroundImage: "url(" + thumbnailUrl + ")" }
            : null;
        var thumbnailClassNames = classnames_1.default(vertical_card_scss_includeInitial_1.default.thumbnail, (_a = {},
            _a[vertical_card_scss_includeInitial_1.default['with-play-icon']] = isPlayable && thumbnailUrl,
            _a));
        return (react_1.default.createElement("div", { className: thumbnailClassNames, style: style },
            react_1.default.createElement("div", { className: vertical_card_scss_includeInitial_1.default.icon },
                react_1.default.createElement(thumbnail_placeholder_icon_1.default, { type: type, itemType: itemType, thumbnailUrl: thumbnailUrl }))));
    };
    VerticalVideoCard.prototype.render = function () {
        var _a;
        var _b = this.props, cardData = _b.cardData, className = _b.className, isAccessible = _b.isAccessible, labels = _b.labels;
        var text = cardData.text, url = cardData.url, type = cardData.type, liveLabel = cardData.liveLabel;
        var hasCTA = this.hasCTA();
        var isSocialCard = type === types_1.VIDEO_CARD_TYPES.SOCIAL;
        var linkClassNames = classnames_1.default(vertical_card_scss_includeInitial_1.default.link, (_a = {},
            _a[vertical_card_scss_includeInitial_1.default['is-social-card']] = isSocialCard,
            _a));
        return (react_1.default.createElement("div", { className: className, tabIndex: "-1", "data-hook": "action-card" },
            react_1.default.createElement("a", { className: linkClassNames, onClick: this.handleCardClick, href: url, "aria-hidden": !isAccessible, tabIndex: isAccessible ? 0 : -1, rel: "noopener noreferrer", target: "_blank" },
                react_1.default.createElement("div", { className: vertical_card_scss_includeInitial_1.default.container },
                    this.renderThumbnail(),
                    react_1.default.createElement("div", { className: vertical_card_scss_includeInitial_1.default['content-wrapper'] },
                        react_1.default.createElement("div", { className: vertical_card_scss_includeInitial_1.default.content },
                            react_1.default.createElement("div", { className: vertical_card_scss_includeInitial_1.default.description }, text && (react_1.default.createElement(description_1.default, { text: text, liveLabel: liveLabel, isShrinkable: isSocialCard, withSeparator: isSocialCard ? false : hasCTA }))),
                            hasCTA && (react_1.default.createElement(cta_1.default, { labels: labels, isAccessible: isAccessible, cardData: cardData }))))))));
    };
    VerticalVideoCard.propTypes = {
        className: prop_types_1.default.string,
        isAccessible: prop_types_1.default.bool,
        cardData: prop_types_1.default.object,
        onCardClick: prop_types_1.default.func,
        labels: prop_types_1.default.object,
    };
    VerticalVideoCard.defaultProps = {
        onCardClick: lodash_1.noop,
    };
    VerticalVideoCard = tslib_1.__decorate([
        withStyles_1.withStyles(vertical_card_scss_includeInitial_1.default)
    ], VerticalVideoCard);
    return VerticalVideoCard;
}(react_1.default.Component));
exports.default = VerticalVideoCard;
//# sourceMappingURL=vertical-card.js.map